import {
  StyledDataGrid,
  useDataGridContext,
} from '@issuemanager/apps/client/components';
import { Stack } from '@mui/material';
import { useEffect } from 'react';
import { useFlattenedIssueTypes } from '../../../../../features/issue-types';
import { IssueTypesGridToolbar } from './issue-types-grid-toolbar';
import { IssueTypesTableEmpty } from './issue-types-table-empty';
import { useFlattenedIssueTypesQueryParams } from './use-flattened-issue-types-query-params';
import { useIssueTypesGridColumns } from './use-issue-types-grid-columns';

export function IssueTypesGrid() {
  const dataGridContext = useDataGridContext();

  const queryParams = useFlattenedIssueTypesQueryParams(
    dataGridContext.sortModel,
    dataGridContext.filterModel,
  );

  const issueTypesQuery = useFlattenedIssueTypes({
    sort: queryParams.sort,
    filter: {
      searchTerm: dataGridContext.searchTerm,
      ...queryParams.filter,
    },
    page: dataGridContext.paginationModel.currentPage,
    limit: dataGridContext.paginationModel.pageSize,
  });

  useEffect(() => {
    dataGridContext.setSortModel([]);
  }, []);

  useEffect(() => {
    if (!issueTypesQuery.data) return;

    dataGridContext.setPaginationModel((prevState) => ({
      ...prevState,
      total: issueTypesQuery.data.meta.itemCount,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [issueTypesQuery.dataUpdatedAt]);

  const { columns } = useIssueTypesGridColumns();

  return (
    <div data-testid='categories-grid'>
      <Stack spacing={4}>
        <StyledDataGrid
          error={issueTypesQuery.isError}
          components={{
            NoRowsOverlay: IssueTypesTableEmpty,
            Toolbar: IssueTypesGridToolbar,
          }}
          loading={issueTypesQuery.isFetching}
          disableSelectionOnClick
          columns={columns}
          rows={issueTypesQuery.data?.data ?? []}
          getRowId={(row) => row.path}
        />
      </Stack>
    </div>
  );
}
